import { Palette } from 'react-leaflet-hotline';

export function pathColorPalette(): Palette {
  const palette: Palette = [
    { r: 255, g: 0, b: 0, t: 0 },
    { r: 255, g: 128, b: 0, t: 0 },
    { r: 255, g: 255, b: 0, t: 0 },
    { r: 0, g: 220, b: 0, t: 0 },
    { r: 0, g: 255, b: 255, t: 0 },
    { r: 0, g: 0, b: 255, t: 0 },
    { r: 193, g: 0, b: 255, t: 0 },
  ];

  palette.forEach((p, index) => {
    p.t = index / (palette.length - 1);
  });

  return palette;
}
